"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weAreServer = exports.useSSR = exports.Device = void 0;
/**
 * This is a reference implementation of the useSSR hook from use-ssr: https://github.com/iamthesiz/use-ssr/blob/master/useSSR.ts
 * The license for the content in this file is goverened by the original project's license: https://github.com/iamthesiz/use-ssr/blob/master/license.md
 */
let Device = exports.Device = /*#__PURE__*/function (Device) {
  Device["Browser"] = "browser";
  Device["Server"] = "server";
  return Device;
}({});
const {
  Browser,
  Server
} = Device;
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const device = canUseDOM ? Browser : Server;
const SSRObject = {
  isBrowser: device === Browser,
  isServer: device === Server,
  device,
  canUseWorkers: typeof Worker !== "undefined",
  canUseEventListeners: device === Browser && !!window.addEventListener,
  canUseViewport: device === Browser && !!window.screen
};
const assign = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce((acc, obj) => ({
    ...acc,
    ...obj
  }), {});
};
const values = obj => Object.keys(obj).map(key => obj[key]);
const toArrayObject = () => assign((values(SSRObject), SSRObject));
let useSSRObject = toArrayObject();
const weAreServer = () => {
  SSRObject.isServer = true;
  useSSRObject = toArrayObject();
};
exports.weAreServer = weAreServer;
const useSSR = () => useSSRObject;
exports.useSSR = useSSR;